import React, {useState, useRef, useEffect} from 'react';
import {getModalAttribute} from 'lib/utils';
import {t} from 'lib/i18n';

/**
 * 헤더 공통 컴포넌트
 */

interface IHeaderProps {
  editMode: string;
}

declare global {
  interface Window {
    SOOP_UI: any;
  }
}

const Header = ({editMode}: IHeaderProps) => {
  const [modal] = useState(false);
  const [, setMarginState] = useState('-266px 0px 0px -258.5px');
  const popupWrapRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault(); // 최신 브라우저에서는 필요
      e.returnValue = ''; // 기본 경고 메시지 표시
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (!editMode) {
      return;
    }

    const gnb = document.getElementById('soop-gnb');
    const nav = window.SOOP_UI.SoopNavigation(gnb, null, null, {
      logoSecondary:
        editMode === 'section' ? t('VOD 구간 편집기') : t('편집 VOD 만들기'),
      shouldHideSearchBar: true,
      shouldHideDarkModeSelector: true,
      shouldShowAdvertise: false,
    });

    nav.handleAuthorized((user: any) => {
      console.log('handleAuthorized::', user);
    });
  }, [editMode]);

  useEffect(() => {
    if (!popupWrapRef.current) return;

    const {width, height} = getModalAttribute(popupWrapRef.current);

    setMarginState(`-${height}px 0px 0px -${width}px`);
  }, [modal]);

  return (
    <div className='webeditor_header' id='webplayer_top'>
      <div id='soop-gnb'></div>
    </div>
  );
};

export default Header;
